import {
    FETCH_RETURN_LABEL_REQUEST,
    FETCH_RETURN_LABEL_SUCCESS,
    FETCH_RETURN_LABEL_ERROR,
    CLEAR_RETURN_LABEL,
} from '../constants/ActionTypes'
import { timeout, delay } from '@ynap/promise-utils'
import { OrderHistory } from '@ynap/api-utils'
import { push } from 'connected-react-router'

function fetchReturnLabelRequest() {
    return {
        type: FETCH_RETURN_LABEL_REQUEST,
    }
}

function fetchReturnLabelSuccess() {
    return {
        type: FETCH_RETURN_LABEL_SUCCESS,
    }
}

function fetchReturnLabelError(error) {
    return {
        type: FETCH_RETURN_LABEL_ERROR,
        error,
    }
}

function clearReturnLabel() {
    return {
        type: CLEAR_RETURN_LABEL,
    }
}

export default function fetchReturnLabel(returnId, externalOrderId, email) {
    return (dispatch, getState, fetch) => {
        const { config, locale, router = {}, uberToken } = getState()
        const { country } = locale
        const { location = {} } = router
        const { pathname } = location
        const { clientRequest } = config.head || config
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce
        const { brandId } = config.watsonService || config.global.application

        dispatch(fetchReturnLabelRequest())

        const request = OrderHistory.getReturnLabel({
            baseUrl,
            brandId,
            country,
            email,
            returnId,
            externalOrderId: externalOrderId.toUpperCase(),
            uberToken,
            clientId,
            clientSecret,
        })

        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((res) => {
                const { ok, status } = res

                if (ok) {
                    return res.json().then(() => dispatch(fetchReturnLabelSuccess()))
                } else if (status === 400) {
                    return res.json().then((errorResponse) => dispatch(fetchReturnLabelError(errorResponse)))
                } else if (status === 401 || status === 403) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`))
                }
            })
            .catch((error) => {
                dispatch(fetchReturnLabelError(error))
            })
    }
}

export function clearReturnLabelState() {
    return (dispatch) => {
        dispatch(clearReturnLabel())
    }
}
